import React from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';
import { useTranslation } from '../../../context/TranslationContext';

interface AddDatasetDialogProps {
  open: boolean;
  onClose: () => void;
  newDatasetName: string;
  setNewDatasetName: (name: string) => void;
  handleAddDataset: () => void;
  handleKeyPress: (e: React.KeyboardEvent, handleAddDataset: () => void) => void;
}

const AddDatasetDialog: React.FC<AddDatasetDialogProps> = ({ open, onClose, newDatasetName, setNewDatasetName, handleAddDataset, handleKeyPress }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("Add New Dataset")}</DialogTitle>
      <DialogContent>
        <TextField
          label={t("Dataset Name")}
          value={newDatasetName}
          onChange={(e) => setNewDatasetName(e.target.value.slice(0, 30))}
          fullWidth
          onKeyPress={(e) => handleKeyPress(e, handleAddDataset)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("Cancel")}
        </Button>
        <Button onClick={handleAddDataset} color="primary">
          {t("Add")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDatasetDialog;
